import { jsx as _jsx } from "react/jsx-runtime";
import Tab from "@mui/material/Tab";
import { slugify } from "healthex-common/utils";
export const HXTab = (props) => {
    const { analyticsId, label, ...rest } = props;
    const heapId = analyticsId ? slugify(analyticsId) : typeof label === "string" ? slugify(label) : undefined;
    return _jsx(Tab, { "data-heap-id": heapId, label: label, ...rest });
};
export default HXTab;
